module.exports = __webpack_public_path__ + "media/images/home/mini/sc3-ef2c3870dc1df3c26f50b42c584e49ff.png";